import { render, staticRenderFns } from "./ActividadesEditar.vue?vue&type=template&id=556757ba&scoped=true"
import script from "./ActividadesEditar.vue?vue&type=script&lang=js"
export * from "./ActividadesEditar.vue?vue&type=script&lang=js"
import style0 from "./ActividadesEditar.vue?vue&type=style&index=0&id=556757ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556757ba",
  null
  
)

export default component.exports